import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppShell from "../components/AppShell";
import FlowWorkspace from "../components/FlowWorkspace";
import { getProject, getFlow } from "../lib/api";
import { basename } from "../lib/format";
import { Flame } from "lucide-react";

export default function FlowPage() {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [flow, setFlow] = useState(null);

  useEffect(() => {
    getProject(projectId).then(setProject).catch(() => {});
    getFlow(projectId).then(setFlow).catch(() => {});
  }, [projectId]);

  const hotEntries = flow?.hot_files
    ? Object.entries(flow.hot_files).sort((a, b) => b[1] - a[1])
    : [];

  return (
    <AppShell>
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-6 sm:py-10">
        <div className="mb-6">
          <span className="text-[11px] uppercase tracking-[0.18em] text-[#4b5563] font-semibold">
            Flow Workspace
          </span>
          <h1 className="text-3xl tracking-tight text-[#0b1220] mt-1.5 font-semibold">
            How <span className="gradient-text">{project?.name || "this project"}</span> is built
          </h1>
          <p className="text-sm text-[#4b5563] max-w-xl mt-2 leading-relaxed">
            Each node is a real folder. Pulsing borders = activity in the last 7 days. Click any
            node to inspect recent files.
          </p>
        </div>

        {hotEntries.length > 0 && (
          <div
            data-testid="hot-zones-banner"
            className="mb-5 rounded-2xl p-4 sm:p-5 border border-amber-200/70 relative overflow-hidden"
            style={{
              background:
                "linear-gradient(135deg, rgba(251,191,36,0.08) 0%, rgba(244,63,94,0.05) 100%)",
            }}
          >
            <div className="flex items-center gap-2 mb-2">
              <span className="inline-flex items-center justify-center w-7 h-7 rounded-md bg-gradient-to-br from-amber-400 to-rose-500 text-white shadow-sm">
                <Flame size={14} strokeWidth={2.4} />
              </span>
              <span className="text-[11px] uppercase tracking-[0.18em] text-rose-700 font-bold">
                Hot zones · mid-refactor right now
              </span>
            </div>
            <ul className="flex flex-wrap gap-2">
              {hotEntries.map(([f, streak]) => (
                <li
                  key={f}
                  className="px-2.5 py-1 rounded-full bg-white/70 border border-amber-200 text-[12px] text-[#111827] flex items-center gap-1.5"
                  title={f}
                >
                  <span className="font-mono font-semibold">{basename(f)}</span>
                  <span className="text-[10px] text-rose-600 font-semibold">{streak} sessions</span>
                </li>
              ))}
            </ul>
            <p className="mt-2 text-[11px] text-[#6b7280]">
              Files dominating 3+ consecutive sessions. They're where your effort is concentrated.
            </p>
          </div>
        )}

        <FlowWorkspace projectId={projectId} />
      </div>
    </AppShell>
  );
}
